module.exports = __webpack_public_path__ + "img/image-home-joven.049df0f2.svg";